import { useViewerQuery } from "../queries/viewerQuery";
import { PETMAMMOTH } from "../root/tutorial/steps/PetMammoth";
import { TUTORIALDONE } from "../root/tutorial/steps/Verdict";

export const useOnboardingCompleted = () => {
  const { hintWasSeen } = useViewerQuery();
  return hintWasSeen(PETMAMMOTH) || hintWasSeen(TUTORIALDONE);
};

export default useOnboardingCompleted;
